__turbopack_context__.v({
  "section": "BoardSection-module-scss-module__1Fxl2q__section",
});
